module.exports = __webpack_public_path__ + "img/accepted-docs.8b9fb43b.svg";